import {
  createFormState,
  required,
  hasLength,
  isValidMonth,
  dateAfterToday,
  onlyExpirationDate,
  validateWhen,
  onlyIntegers,
  matchesRegex
} from "redux-freeform";

const formState = {
  country: {
    defaultValue: "US",
    validators: [required()]
  },
  expirationDate: {
    validators: [
      required(),
      hasLength(4, 4),
      isValidMonth(0),
      dateAfterToday("MMYY", "month", true)
    ],
    constraints: [onlyExpirationDate(), hasLength(0, 4)]
  },
  zipCode: {
    validators: [
      required(),
      validateWhen(
        validateWhen(hasLength(5, 5), hasLength(0, 5)),
        matchesRegex("US"),
        "country"
      ),
      validateWhen(
        validateWhen(hasLength(9, 9), hasLength(6, 9)),
        matchesRegex("US"),
        "country"
      )
    ],
    constraints: [
      validateWhen(onlyIntegers(), matchesRegex("US"), "country"),
      validateWhen(hasLength(0, 9), matchesRegex("US"), "country")
    ]
  }
};

export const { reducer, mapStateToProps, mapDispatchToProps } = createFormState(
  formState
);
